export default "__VITE_ASSET__CLKFcs1e__"